document.addEventListener("DOMContentLoaded", () => {

    // Sticky header
    // =============

    (() => {
        const header = document.querySelector("[data-sticky-header]");
        const headerOffset = header.offsetTop - window.scrollY;

        let lastScroll = 0;

        const hidingOnScroll = () => {
            const currentScroll = window.pageYOffset;

            if (currentScroll > headerOffset) {
                header.classList.add('is-sticked');
                header.classList[currentScroll > lastScroll && currentScroll > 80 ? 'add' : 'remove']('is-up');
            } else {
                header.classList.remove('is-sticked');
                header.classList.remove('is-up');
            }

            lastScroll = currentScroll;
        }

        window.addEventListener('scroll', () => hidingOnScroll(), {passive: true});
        hidingOnScroll();
    })();
});